import { Configuration as msalConfiguration } from "@azure/msal-browser";

const isProduction = import.meta.env.PROD;

// If development, use localhost
const redirectUrl = isProduction
	? (import.meta.env.VITE_MSAL_REDIRECT_URL ?? "")
	: "http://localhost:3006";

export const msal: msalConfiguration = {
	auth: {
		clientId: import.meta.env.VITE_MSAL_CLIENT_ID ?? "",
		authority: import.meta.env.VITE_MSAL_AUTHORITY,
		redirectUri: redirectUrl,
	},
	cache: {
		cacheLocation: "sessionStorage",
		storeAuthStateInCookie: false,
	},
};

export const loginRequest = {
	scopes: ["User.Read"],
};

// S2 API configuration (pymble-apis / FastAPI)
export const api_s2 = {
	baseURL: isProduction
		? "https://papi.pymblelc.nsw.edu.au/"
		: (import.meta.env.VITE_API_S2_BASE_URL ?? "http://localhost:8000/"),
	scopes: [
		import.meta.env.VITE_API_S2_SCOPES ?? "api://pymble-apis/access",
	],
};

// App configuration
export const app = {
	defaultNoticeImg:
		"https://pymblelc.blob.core.windows.net/assets/banners/REN_7254.jpg",
	defaultGroupIcon:
		"https://pymblelc.blob.core.windows.net/assets/pymble-p.png",
	colorPrimary: "#002f67",
	approvalLockPeriod: 3,
	attendanceExcemptionForm: {
		url: "https://pymblelc.blob.core.windows.net/assets/forms/Application-for-Exemption-from-Attendance-Form.pdf",
		title: "Application for Exemption from Attendance",
		text: "Leave Form",
	},
	privacyPolicyUrl:
		"https://www.pymblelc.nsw.edu.au/wp-content/uploads/2021/02/Privacy-Policy.pdf",
	securityPolicyUrl:
		"https://www.pymblelc.nsw.edu.au/wp-content/uploads/2021/02/Security-Policy.pdf",
	pymbleHandbookUrl:
		"https://www.pymblelc.nsw.edu.au/mypymble/?toKnowledgeBase=true",
	userGuideUrl:
		"https://sites.google.com/pymblelc.nsw.edu.au/parent-portal-2021/",
	googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY ?? "",
};
